
import React from "react";

export const EventDetailsLoading: React.FC = () => {
  return <div className="container py-8">Loading...</div>;
};
